import React, { useState } from 'react';
import PriceTable from './components/PriceTable';
import SubHeader from './components/SubHeader';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';

const PriceTableReport = () => {
  const [checkInDate, setCheckInDate] = useState(moment().tz(TIME_ZONE))
  const [checkOutDate, setCheckOutDate] = useState(moment().tz(TIME_ZONE).add(9, 'days'))

  return (
    <>
      <SubHeader
        checkInDate={checkInDate}
        setCheckInDate={setCheckInDate}
        checkOutDate={checkOutDate}
        setCheckOutDate={setCheckOutDate}
      />
      <PriceTable checkInDate={checkInDate} checkOutDate={checkOutDate} />
    </>
  );
};

export default PriceTableReport;
